import type { Control } from "react-hook-form";
import {
	ClientPortfolioDomainEnum,
	type ProductCategoryKeyEnum,
} from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type {
	CommoditiesEditFormInput,
	CommoditiesEditFormOutput,
} from "web_myplann/Portfolio/Forms/CommoditiesForm/commoditiesFormSchema";
import { InvestmentAdditionalFields } from "web_myplann/Portfolio/Forms/InvestmentForm/InvestmentAdditionalFields";
import { InvestmentBasicFields } from "web_myplann/Portfolio/Forms/InvestmentForm/InvestmentBasicFields";
import { InvestmentToolsSection } from "web_myplann/Portfolio/Forms/InvestmentForm/InvestmentToolsSection";

type CommoditiesEditFormFieldsProps = {
	control: Control<
		CommoditiesEditFormInput,
		unknown,
		CommoditiesEditFormOutput
	>;
	productCategory?: ProductCategoryKeyEnum | null;
};

export const CommoditiesEditFormFields = ({
	control,
	productCategory,
}: CommoditiesEditFormFieldsProps) => {
	const { t } = useResource();

	return (
		<>
			<InvestmentBasicFields
				control={control}
				productCategory={productCategory}
				domain={ClientPortfolioDomainEnum.Commodities}
				namePlaceholder={t(
					Resources.Portfolio.AddCommodities.Placeholders.name,
				)}
			/>
			<InvestmentToolsSection control={control} />
			<InvestmentAdditionalFields control={control} />
		</>
	);
};
